module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"selectCorporation":"Please select an account","missedCorporation":"Missed account"}}')
  delete Component.options._Ctor
}
